/* MyPitz cart drawer behaviour (snippets/cart-drawer.liquid).
   - <mpz-cart-timer>: MM:SS countdown that starts the first time the drawer opens and keeps going across
     drawer re-renders (cart changes). When it runs out it continues from 01:30.
   - <mpz-cart-upsell>: variant dropdowns + "add" button that adds the product and re-renders the drawer.
   - <mpz-cart-discount>: empty-code message; otherwise the form goes to /checkout?discount=CODE. */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // One countdown per page view, shared by every <mpz-cart-timer> the drawer re-renders, so a cart change
  // does not restart it (same as the previous theme).
  const countdown = { remaining: null, interval: null, clocks: new Set() };

  function renderClocks() {
    const text = pad(Math.floor(countdown.remaining / 60)) + ':' + pad(countdown.remaining % 60);
    countdown.clocks.forEach((clock) => {
      clock.textContent = text;
    });
  }

  function startCountdown() {
    if (countdown.interval) return;
    countdown.interval = setInterval(() => {
      countdown.remaining -= 1;
      if (countdown.remaining <= 0) countdown.remaining = 90;
      renderClocks();
    }, 1000);
  }

  if (!customElements.get('mpz-cart-timer')) {
    customElements.define(
      'mpz-cart-timer',
      class MpzCartTimer extends HTMLElement {
        connectedCallback() {
          if (countdown.remaining === null) countdown.remaining = parseInt(this.dataset.duration, 10) || 300;
          countdown.clocks.add(this);
          renderClocks();
          if (countdown.interval) return;

          this.drawer = this.closest('cart-drawer');
          if (!this.drawer || this.drawer.classList.contains('active')) {
            startCountdown();
            return;
          }
          this.observer = new MutationObserver(() => {
            if (!this.drawer.classList.contains('active')) return;
            this.observer.disconnect();
            startCountdown();
          });
          this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        }

        disconnectedCallback() {
          countdown.clocks.delete(this);
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  if (!customElements.get('mpz-cart-upsell')) {
    customElements.define(
      'mpz-cart-upsell',
      class MpzCartUpsell extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.button = this.querySelector('.mpz-cart-upsell__add');
          this.label = this.querySelector('.mpz-cart-upsell__add-label');
          this.idInput = this.form && this.form.querySelector('input[name="id"]');
          if (!this.form || !this.button || !this.idInput) return;
          this.addLabel = this.label ? this.label.innerHTML : '';

          const json = this.querySelector('script[data-mpz-variants]');
          try {
            this.variants = json ? JSON.parse(json.textContent) : [];
          } catch (e) {
            this.variants = [];
          }

          this.selects = Array.from(this.querySelectorAll('select[data-option-index]'));
          this.selects.forEach((select) => select.addEventListener('change', () => this.onOptionChange()));
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
        }

        onOptionChange() {
          const chosen = this.selects.map((select) => select.value);
          const variant = this.variants.find((v) => v.options.every((value, i) => value === chosen[i]));
          if (variant) this.idInput.value = variant.id;
          const available = Boolean(variant && variant.available);
          this.button.disabled = !available;
          if (this.label) this.label.innerHTML = available ? this.addLabel : this.button.dataset.soldOut || '';
        }

        onSubmit(event) {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') return; // plain form post
          event.preventDefault();
          if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

          this.button.setAttribute('aria-disabled', 'true');
          this.button.classList.add('loading');
          const spinner = this.button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          const variantId = parseInt(this.idInput.value, 10);
          const sections = drawer.getSectionsToRender().map((section) => section.id);
          const errors = document.getElementById('CartDrawer-CartErrors');

          fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: sections.join(','),
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json())
            .then((state) => {
              if (state.status || !state.sections) {
                if (errors) errors.textContent = state.description || state.message || window.cartStrings.error;
                return;
              }
              drawer.classList.remove('is-empty');
              drawer.renderContents(state);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mpz-cart-upsell', cartData: state, variantId: variantId });
              }
            })
            .catch(() => {
              if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
            })
            .finally(() => {
              // On success this card is usually replaced by the re-render; reset it in case it is not.
              this.button.classList.remove('loading');
              this.button.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
            });
        }
      }
    );
  }

  if (!customElements.get('mpz-cart-discount')) {
    customElements.define(
      'mpz-cart-discount',
      class MpzCartDiscount extends HTMLElement {
        connectedCallback() {
          const form = this.querySelector('form');
          const input = form && form.querySelector('input[name="discount"]');
          const error = this.querySelector('.mpz-cart-discount__error');
          if (!form || !input) return;

          form.addEventListener('submit', (event) => {
            const code = input.value.trim();
            if (!code) {
              event.preventDefault();
              if (error) error.hidden = false;
              return;
            }
            input.value = code;
            if (error) error.hidden = true;
          });
          input.addEventListener('input', () => {
            if (error) error.hidden = true;
          });
        }
      }
    );
  }
})();
